import React from 'react';
import { Box, Container } from '@material-ui/core/'

export default () => {
  return (
    <Box bgcolor="secondary.main" className="Footer" py={2.5}>
      <Container maxWidth="xl" align="right">© uBelong 2021</Container>
    </Box>
  );
}